export const patronLevelColorCode = {
  'Heart of the Nation': '#00EAFD',
  'Heart of the Region': '#73C429',
  'Heart of the City': '#F7CB30',
  'Heart of the Community': '#FF00FF',
  'Heart of the Neighborhood': '#FF1443',
  'The Heart of Humanity & Service': '#4F46E5',
  'Exclusive Vendor Partners': '#FF773D',
};
export default patronLevelColorCode;
